import React from 'react'
import { useSelector } from 'react-redux'
import Index from '../Routes/index'

const App = () => {
    const { 
        rex_time_scroll
    } = useSelector(({loginGrow}) => loginGrow)

    return (
        <div
            style={{
                height: '100vh',
                overflow: rex_time_scroll ? 'hidden' : 'inherit' 
            }}
        >
            <Index />
        </div>
    )
}

export default App